<div
  class="container-label-avatar"
  title="{{title}}"
  [style.background-color]="cor ? (cor.corSecundariaHexa) + '27' : ''"
  [style.border-color]="cor ? cor.corPrincipalHexa : ''">
  <label class="label-avatar" [ngClass]="cssClass">{{ primeiraLetra }}{{ segundaLetra }}</label>
</div>